import { render, staticRenderFns } from "./RsQuestionMatrixCheck.vue?vue&type=template&id=61c86702"
import script from "./RsQuestionMatrixCheck.vue?vue&type=script&lang=js"
export * from "./RsQuestionMatrixCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports